import { Injectable, OnDestroy } from '@angular/core';
import { SwUpdate, VersionEvent } from '@angular/service-worker';
import { Subscription, interval } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class UpdateService implements OnDestroy {
  private subscription?: Subscription;

  constructor(private readonly swUpdate: SwUpdate) {
    if (!swUpdate.isEnabled) {
      return;
    }

    // Check regularly for new versions.
    this.subscription = interval(60 * 60 * 1000).subscribe(() => this.swUpdate.checkForUpdate());

    // Reload when a new version is ready.
    this.swUpdate.versionUpdates.subscribe((event: VersionEvent) => {
      if (event.type === 'VERSION_READY') {
        this.swUpdate.activateUpdate().then(() => document.location.reload());
      }
    });
  }

  public ngOnDestroy(): void {
    this.subscription?.unsubscribe();
  }
}
